import React, { useEffect } from "react";
import RCCodeTemplate from "../../../Templetes/Categories/Details/RCCode/RCCode.template";

const RCCodePage = () => {
  useEffect(() => {
    document.title = "International Robot Challenge - RC Code";
  }, []);
  return <RCCodeTemplate />;
};

export default RCCodePage;

